import { createContext, useContext, useMemo, useState } from 'react';
import * as React from 'react';

import { initialRectState } from './richTextProvider.consts';
import { RichTextContainerContext } from './richTextProvider.types';

type Props = {
  children: React.ReactNode;
};

const RichTextContext = createContext<RichTextContainerContext>({} as RichTextContainerContext);

export const useRichTextContext = (): RichTextContainerContext => useContext(RichTextContext);

export const RichTextProvider: React.FC<React.PropsWithChildren<Props>> = ({ children }) => {
  const [rect, setRect] = useState<DOMRect>(initialRectState);

  const value = useMemo(
    () => ({
      editorContainer: {
        rect,
        setRect,
      },
    }),
    [rect]
  );

  return <RichTextContext.Provider value={value}>{children}</RichTextContext.Provider>;
};
